import actions from './actions';
import { setTokenStore, login, logout } from 'Services/authServices';
import parseJwt from 'Utilities/parseJwt';


export const setToken = (payload) =>
  async function thunk(dispatch) {
    try {
      payload.user = {...parseJwt(payload.token), ...payload.dbUser, ...payload.paymentStatus};
      payload.tenant = payload.dbTenant;
      await setTokenStore(payload);
      dispatch(actions.login.success(payload));
    } catch (error) {
      await dispatch(actions.login.failure(error));
    }
  };

export const Login = (payload) =>
  async function thunk(dispatch) {
    try {
      dispatch(actions.login.request(payload));
      const response = await login(payload);

      dispatch(actions.login.success(response));
    } catch (error) {
      await dispatch(actions.login.failure(error));
    }
  };

export const Signout = (payload) =>
  async function thunk(dispatch) {
    try {
      await dispatch(actions.signout.request());
      localStorage.clear();
      await logout();
      await dispatch(actions.signout.success());
    } catch (error) {
      await dispatch(actions.signout.failure(error));
    }
  };
